import '../../App.css';
import InfoSection from '../InfoSection';
import react from 'react';

function Information() {
  return (
    <>
      <InfoSection />
    </>
  );
}

export default Information;